import type { RouteObject } from "react-router";

const loadPaymentSuccessPage = () =>
  import("@/features/checkout/pages/payment-success-page");
const loadPaymentFailurePage = () =>
  import("@/features/checkout/pages/payment-failure-page");
const loadPaymentPendingPage = () =>
  import("@/features/checkout/pages/payment-pending-page");

export const legacyPaymentResultRoutes: RouteObject[] = [
  { path: "success", lazy: loadPaymentSuccessPage },
  { path: "failure", lazy: loadPaymentFailurePage },
  { path: "pending", lazy: loadPaymentPendingPage },
];

export const canonicalPaymentResultRoutes: RouteObject[] = [
  { path: "exito", lazy: loadPaymentSuccessPage },
  { path: "error", lazy: loadPaymentFailurePage },
  { path: "pendiente", lazy: loadPaymentPendingPage },
];
